import { post, get } from './ajax';

export function postApi(url, data) {
    return post("/api" + url, data);
}

export function getApi(url, data) {
    return get("/api" + url, data);
}
